import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { useClientTranslations } from "../../lib/i18n/client";
import type { EducationContent } from "../../services/educationService";
import { ContentCard } from "./ContentCard";
import styles from "./RecommendedContent.module.css";

interface RecommendedContentProps {
	items: EducationContent[];
	/** When true, drop the full-bleed negative margin so the carousel stays
	 * inside a padded container (e.g. the Home education-suggestions box). */
	contained?: boolean;
}

export function RecommendedContent({
	items,
	contained = false,
}: RecommendedContentProps) {
	const { direction } = useClientTranslations("education");

	return (
		<div className={contained ? styles.containerContained : styles.container}>
			<Swiper
				// Swiper reads `dir` only at init — remount on direction change so a
				// live language switch resets slide positions/pagination correctly.
				key={direction}
				modules={[Pagination]}
				slidesPerView="auto"
				spaceBetween={12}
				pagination={{ clickable: true }}
				dir={direction}
				threshold={10}
				touchStartPreventDefault={false}
				resistanceRatio={0.65}
				className={styles.swiper}
			>
				{items.map((item, index) => (
					<SwiperSlide key={item.id} className={styles.slide}>
						<ContentCard content={item} index={index} />
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
}
